import React from 'react';
import { MessageCircle, ArrowDown, Award, Zap, ShieldCheck, DollarSign } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-[90vh] flex flex-col justify-center overflow-hidden" data-id="element-176" data-mp="9kjxsrx55a59">
      {/* Full-bleed background image */}
      <img src="https://cdn.magicpatterns.com/uploads/291wi5FGm7SZuRDHLwxpjd/aselite.png" alt="Website profesional para contractors mostrado en laptop y celular" className="absolute inset-0 w-full h-full object-cover object-[center_70%]" data-id="element-177" data-mp="4mrxb9ifkfpg" />
      {/* Dark scrim for readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/80 to-dark/60" data-id="element-178" data-mp="s9q7jpfyirex"></div>
      <div className="absolute inset-0 bg-dark/40" data-id="element-179" data-mp="nbey3ftkqix8"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16 lg:pt-40 lg:pb-20 text-center" data-id="element-180" data-mp="3d1s9sv56tfs2">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight mb-6 drop-shadow-2xl" data-id="element-181" data-mp="381nqyygt48yo">
          Haz Que Tu Negocio Se Vea{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-300 to-gold-600" data-id="element-182" data-mp="3eb91x367hayy">
            Tan Profesional Como Tu Trabajo.
          </span>
          <span className="block text-2xl md:text-4xl lg:text-5xl mt-4 text-gray-200 font-bold" data-id="element-183" data-mp="359j6znd47twf">
            Un Website Que Te Trae Clientes.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed drop-shadow-lg" data-id="element-184" data-mp="2vi50uwqnrvub">
          Páginas web premium para contractors locales por un solo pago de{' '}
          <strong className="text-white" data-id="element-185" data-mp="iboyiltrcouw">$250</strong>. Listo en menos de 72
          horas.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-186" data-mp="ddwyt5mvfyg5">
          <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center px-8 py-4 text-base font-bold rounded-full text-dark bg-gold hover:bg-gold-400 transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-187" data-mp="x1nvil9ktu8s">
            <MessageCircle className="w-5 h-5 mr-2" data-id="element-188" data-mp="21amx7d2zpynx" />
            ESCRÍBENOS POR WHATSAPP →
          </a>
          <a href="#portafolio" className="w-full sm:w-auto flex items-center justify-center px-8 py-4 text-base font-bold rounded-full text-white border border-white/30 bg-dark/40 backdrop-blur-sm hover:bg-white/10 transition-all" data-id="element-189" data-mp="26a98vi3676um">
            Ver Nuestro Trabajo <ArrowDown className="w-4 h-4 ml-2" data-id="element-190" data-mp="2kyvmnfd5fqjq" />
          </a>
        </motion.div>

        {/* Trust badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto border-t border-white/10 pt-10" data-id="element-191" data-mp="2ozz3o56xnsmj">
          {[{
          icon: Award,
          text: 'Diseño Premium'
        }, {
          icon: Zap,
          text: 'Listo en 72 Horas'
        }, {
          icon: ShieldCheck,
          text: 'Satisfacción Garantizada'
        }, {
          icon: DollarSign,
          text: 'Solo $250 Único Pago'
        }].map((item, i) => <motion.div key={i} whileHover={{
          y: -5
        }} className="flex flex-col items-center justify-center p-4 rounded-2xl hover:bg-white/5 transition-colors cursor-default" data-id="element-192" data-mp="3hpr2e3yf3d29" data-mpi={i}>
              <item.icon className="w-8 h-8 text-gold mb-3" data-id="element-193" data-mp="3ri6lx5pd49p9" />
              <span className="text-sm font-medium text-gray-300 text-center" data-id="element-194" data-mp="3moc1u15uhspn">
                {item.text}
              </span>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}